import React, { useState } from "react";
import styles from "./../../Styles/VideoStudy.module.scss";
import { IoCloseOutline } from "react-icons/io5";
import { BiLoaderAlt } from "react-icons/bi";
import VideoBox from "../../Components/VideoBox";

const videoList_1 = [
  {
    id: 1,
    title:
      "Who was St. Patrick and the History Behind Saint Patrick’s Day / Drive Thru History Special",
    duration: "54:52 mins",
    sourceLink: "https://www.youtube.com/embed/l2hXAkIWWac?si=7PxsFxAc772KEQdz"
  },
  {
    id: 2,
    title: "St Patrick – His Confession",
    duration: "44:32 mins",
    sourceLink: "https://www.youtube.com/embed/C2yIKjPvbT0?si=hGvUupFKaX4G3qBb"
  },
  {
    id: 3,
    title: "How the Irish Helped Save Civilization",
    duration: "25:31 mins",
    sourceLink: "https://www.youtube.com/embed/cQxFcTh5uyg?si=HbpLoHFtTziqrppA"
  }
];

const videoList_2 = [
  {
    id: 1,
    title: "The History of Ireland | Facts Everyone Should",
    duration: "12:21 mins",
    sourceLink: "https://www.youtube.com/embed/JSAKq2WoMFA?si=ddlgAlC8uqF8Q_yw"
  },
  {
    id: 2,
    title: "The Entire History of Ireland",
    duration: "26:03 mins",
    sourceLink: "https://www.youtube.com/embed/ZcG4h3zqB1Y?si=_ZZjKCe-15e4ZOPk"
  }
];
const videoList_3 = [
  {
    id: 1,
    title: "The Troubles explained in 5 minutes",
    duration: "5:16 mins",
    sourceLink: "https://www.youtube.com/embed/gNT-oz5NkSM?si=Yn7bZ0bCDHQT2ih3"
  },
  {
    id: 2,
    title: "Why This Border Still Haunts Ireland Today",
    duration: "13:49 mins",
    sourceLink: "https://www.youtube.com/embed/ksq0sFhmMNU?si=REZKo__QYe14rxgH"
  },
  {
    id: 3,
    title: "The Irish Republican Army | Terrorists or Freedom Fighters?",
    duration: "40:11 mins",
    sourceLink: "https://www.youtube.com/embed/W6Snx_FOhhI?si=h5k2Q5HyjomLeNHZ"
  }
];
const videoList_4 = [
  {
    id: 1,
    title: "Ireland Uncovered: 17 Interesting Facts Most People Don&#39;t Know",
    duration: "8:36 mins",
    sourceLink: "https://www.youtube.com/embed/ihLHESTKHVY?si=ahoBDh73jagcR39E"
  },
  {
    id: 2,
    title: "21 Facts About The Ireland | Irish History | Myths &amp; Culture",
    duration: "15:37 mins",
    sourceLink: "https://www.youtube.com/embed/l7FwNfsLPrg?si=FhVYN5beEeQGFlrh"
  },
  {
    id: 3,
    title: "Things you SHOULD NOT do while visiting IRELAND",
    duration: "26:16 mins",
    sourceLink: "https://www.youtube.com/embed/q3DN9UpsTSg?si=8c5C0NZoTPzYmI7r"
  }
];
const videoList_5 = [
  {
    id: 1,
    title: "Exploring The Giant&#39;s Causeway",
    duration: "4:28 mins",
    sourceLink: "https://www.youtube.com/embed/qw6mJ9RUI6k?si=tgVctaL5pDU5yfHb"
  },
  {
    id: 2,
    title: "The Blood-Soaked History of Dunluce Castle",
    duration: "6:30 mins",
    sourceLink: "https://www.youtube.com/embed/QzdVJMpy83w?si=qBEODkiK7dNQjEMZ"
  },
  {
    id: 3,
    title: "Dunluce Castle, Northern Ireland: Romantic Ruins - Rick Steves",
    duration: "1:44 mins",
    sourceLink: "https://www.youtube.com/embed/Skq0rDypGUg?si=m1wxqqrcp28-iKt2"
  },
  {
    id: 4,
    title: "Ireland’s Cliffs of Moher",
    duration: "12:35 mins",
    sourceLink: "https://www.youtube.com/embed/cp9PDckyvd8?si=wJGGpHEQIAtbk2Mt"
  }
];

function VideoStudy() {
  const [modal, setModal] = useState(false);
  const [videoLink, setVideoLink] = useState("");
  //const [videoLoading, setVideoLoading] = useState(true);

  const closeModal = () => {
    setModal(!modal);
  };

  return (
    <div className="pageContainer">
      <div className="title">Documentaries for the Ireland Tour</div>
      <p className="text">
        Caveat: I don’t necessarily believe some of the dating that is mentioned
        in some of these videos.
      </p>
      <div className={`secondaryTitle ${styles.videoGroupTitle}`}>
        St Patrick and the Irish
      </div>
      {videoList_1.map((item, i) => (
        <button
          onClick={() => {
            setModal(!modal);
            setVideoLink(item.sourceLink);
          }}
          className={styles.videoTitle}
          key={i}
        >
          {item.title}
          <p>{item.duration}</p>
        </button>
      ))}

      <div className={`secondaryTitle ${styles.videoGroupTitle}`}>
        History of Ireland
      </div>
      {videoList_2.map((item, i) => (
        <button
          onClick={() => {
            setModal(!modal);
            setVideoLink(item.sourceLink);
          }}
          className={styles.videoTitle}
          key={i}
        >
          {item.title}
          <p>{item.duration}</p>
        </button>
      ))}

      <div className={`secondaryTitle ${styles.videoGroupTitle}`}>
        The Troubles
      </div>
      {videoList_3.map((item, i) => (
        <button
          onClick={() => {
            setModal(!modal);
            setVideoLink(item.sourceLink);
          }}
          className={styles.videoTitle}
          key={i}
        >
          {item.title}
          <p>{item.duration}</p>
        </button>
      ))}

      {modal ? (
        <VideoBox closeModal={closeModal} videoLink={videoLink} />
      ) : null}
      <div className={`secondaryTitle ${styles.videoGroupTitle}`}>
        Ireland: Interesting Facts
      </div>
      {videoList_4.map((item, i) => (
        <button
          onClick={() => {
            setModal(!modal);
            setVideoLink(item.sourceLink);
          }}
          className={styles.videoTitle}
          key={i}
        >
          {item.title}
          <p>{item.duration}</p>
        </button>
      ))}

      {modal ? (
        <VideoBox closeModal={closeModal} videoLink={videoLink} />
      ) : null}
      <div className={`secondaryTitle ${styles.videoGroupTitle}`}>
        Some Sites:
      </div>
      {videoList_5.map((item, i) => (
        <button
          onClick={() => {
            setModal(!modal);
            setVideoLink(item.sourceLink);
          }}
          className={styles.videoTitle}
          key={i}
        >
          {item.title}
          <p>{item.duration}</p>
        </button>
      ))}

      {modal ? (
        <VideoBox closeModal={closeModal} videoLink={videoLink} />
      ) : null}
    </div>
  );
}

export default VideoStudy;
